module.exports = __webpack_public_path__ + "static/media/related-blog3.d38b8423.jpg";